import config from '../config'
import query from '../api/BaseApi'


export default class User {
  constructor() {
    this.host = config.movie_host;
    this.model = 'user';
  }
  async query({ host = this.host, method, urlParams, bodyPayload, pathPrefix = '/api/v1/', model = this.model, path = '', headers = null }) {
    return await query({
      host: host,
      method: method,
      urlParams: urlParams,
      bodyPayload: bodyPayload,
      pathPrefix: pathPrefix,
      model: model,
      path: path,
      headers: headers,
    })
  }
  async getUserInfo() {
    return await this.query({
      method: 'POST',
      path: "/info",
    })
  }

  async login(bodyPayload = { name: undefined, password: undefined }) {
    return await this.query({
      method: 'POST',
      path: "/login",
      bodyPayload: bodyPayload,
    })
  }

  async logout() {
    return await this.query({
      method: 'POST',
      path: "/logout",
    })
  }

  async getCaptcha(urlParams = { mobile: undefined, category: undefined }) {
    return await this.query({
      method: 'GET',
      path: "/captcha",
      urlParams: urlParams
    })
  }

  async bindMobile(bodyPayload = { mobile: undefined, captcha: undefined }) {
    return await this.query({
      method: 'POST',
      path: "/bind",
      bodyPayload: bodyPayload,
    })
  }
  async unBindMobile(bodyPayload = { mobile: undefined, captcha: undefined }) {
    return await this.query({
      method: 'POST',
      path: "/unbind",
      bodyPayload: bodyPayload,
    })
  }
  async changePasswd(bodyPayload = { password: undefined, new_password: undefined }) {
    return await this.query({
      method: 'POST',
      path: "/change_password",
      bodyPayload: bodyPayload,
    })
  }
  async resetPasswd(bodyPayload = { mobile: undefined, captcha: undefined, password: undefined }) {
    return await this.query({
      method: 'POST',
      path: "/reset_password",
      bodyPayload: bodyPayload,
    })
  }

  // async changePwd(bodyPayload = { mobile: undefined, captcha: undefined }) {
  //   return await this.query({
  //     method: 'POST',
  //     path: "/bind",
  //     bodyPayload: bodyPayload,
  //   })
  // }
  // async resetPwd(bodyPayload = { mobile: undefined, captcha: undefined }) {
  //   return await this.query({
  //     method: 'POST',
  //     path: "/bind",
  //     bodyPayload: bodyPayload,
  //   })
  // }
}